import { render, staticRenderFns } from "./ReportPos.vue?vue&type=template&id=b6fe1770&"
import script from "./ReportPos.vue?vue&type=script&lang=js&"
export * from "./ReportPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports